<template>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-12 col-sm-12 col-xl-12" align="center">
      <Skeletor
        v-if="loading"
        height="40"
        width="50%"
        style="margin-bottom: 0px; margin-top: 15px"
      />
      <h6
        v-else
        style="
          font-weight: bold;
          margin-bottom: 20px;
          line-height: 15px;
          margin-top: 20px;
          font-size: 25px;
          color: #3b4457;
        "
        class="text-center"
      >
        $<span style="font-size: 40px"> {{ availableBalance }}</span>
      </h6>
      <h6
        style="
          font-size: 11px;
          margin-bottom: 20px;
          line-height: 15px;
          color: #67748e;
        "
        class="text-center"
      >
        Saldo disponible para retirar. <br />
        El pago se realizará en 72 horas. <br />
        Valor incluye impuestos.
      </h6>
      <hr class="horizontal dark" />
      <form role="form" autocomplete="off" @submit.prevent="sendCash">
        <div class="row">
          <div
            class="col-lg-12 col-md-12 col-12 col-sm-12 col-xl-12 text-center"
          >
            <button
              class="btn btn-primary btn-sm"
              style="width: 100%"
              :disabled="isDisable"
              type="submit"
            >
              Retirar dinero
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Saldo from "./Saldo.vue";

export default {
  components: {
    Saldo,
  },
  props: {
    userId: {
      type: String,
      required: true,
    },
    tokenAuth: {
      type: String,
      required: true,
    },
    closeMethod: Function, // Adding a new prop for the close method
    availableAmount: {
      type: Number,
    },
  },
  data() {
    return {
      isDisable: this.availableAmount === 0,
      loading: false,
      availableBalance: this.availableAmount,
      number: {
        prefix: "$",
        numeral: true,
        numeralPositiveOnly: true,
        noImmediatePrefix: true,
        rawValueTrimPrefix: true,
        numeralIntegerScale: 9,
        numeralDecimalScale: 2,
      },
      invoiceDetails: {
        name: "Planprocad S.A.",
        ruc: "0993371324001",
        address:
          "Av. de las Americas C.C. Terminal Terrestre bloque B Planta Baja local 19",
        email: "info@planproec.com",
        phone: "0978704579",
      },
      maxBillingDate: null,
    };
  },
  computed: {
    availableAmountTax() {
      return this.availableAmount * 0.15;
    },
    totalInvoiceValue() {
      return this.availableAmount * 1.15;
    },
  },
  watch: {},
  mounted() {
    this.$eventBus.on("reiniciarSaldos", () => {
      this.componentKeySaldos += 1;
    });
    this.calculateMaxBillingDate();
    this.getSaldo();
  },
  methods: {
    executeCloseMethod() {
      if (typeof this.closeMethod === "function") {
        this.closeMethod(); // Execute the passed method
      }
    },
    copyField(fieldValue) {
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(fieldValue)
          .then(() => {
            this.$toast.success(`${fieldValue} copiado exitosamente.`, {
              position: "top-right",
              max: 10,
            });
          })
          .catch((err) => {
            console.error("No se pudo copiar el campo: ", err);
            this.$toast.error("Falla al copiar el campo.", {
              position: "top-right",
              max: 10,
            });
          });
      } else {
        console.error("Clipboard API not available.");
        this.$toast.error("Clipboard functionality not available.", {
          position: "top-right",
          max: 10,
        });
      }
    },
    // calculateMaxBillingDate() {
    //   // Get current date
    //   const currentDate = new Date();

    //   // Get next month
    //   const nextMonth = currentDate.getMonth() + 1;

    //   // Get year for next month
    //   const year =
    //     nextMonth === 12
    //       ? currentDate.getFullYear() + 1
    //       : currentDate.getFullYear();

    //   // Maximum billing date for next month (05th day of next month)
    //   const maxBillingDate = new Date(year, nextMonth, 5);

    //   // Format the date as DD/MM/YYYY
    //   this.maxBillingDate = `${maxBillingDate
    //     .getDate()
    //     .toString()
    //     .padStart(2, "0")}/${(maxBillingDate.getMonth() + 1)
    //     .toString()
    //     .padStart(2, "0")}/${maxBillingDate.getFullYear()}`;
    // },

    calculateMaxBillingDate() {
      // Get current date
      const currentDate = new Date();
      const currentDay = currentDate.getDate();

      // Check if today is after the 5th of the month
      if (currentDay > 5) {
        // Get next month
        const nextMonth = currentDate.getMonth() + 1;
        // Get year for next month
        const year =
          nextMonth === 12
            ? currentDate.getFullYear() + 1
            : currentDate.getFullYear();
        // Maximum billing date for next month (05th day of next month)
        const maxBillingDate = new Date(year, nextMonth, 5);
        // Format the date as DD/MM/YYYY
        this.maxBillingDate = `${maxBillingDate
          .getDate()
          .toString()
          .padStart(2, "0")}/${(maxBillingDate.getMonth() + 1)
          .toString()
          .padStart(2, "0")}/${maxBillingDate.getFullYear()}`;
      } else {
        // Maximum billing date for current month (05th day of current month)
        const maxBillingDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          5
        );
        // Format the date as DD/MM/YYYY
        this.maxBillingDate = `${maxBillingDate
          .getDate()
          .toString()
          .padStart(2, "0")}/${(maxBillingDate.getMonth() + 1)
          .toString()
          .padStart(2, "0")}/${maxBillingDate.getFullYear()}`;
      }
    },

    // copyField(fieldValue) {
    //   if (navigator.clipboard) {
    //     navigator.clipboard
    //       .writeText(fieldValue)
    //       .then(() => {
    //         // Success message
    //         alert(`${fieldValue} copied to clipboard.`); // Replace with your toast or alert system
    //       })
    //       .catch((err) => {
    //         // Handle errors if the copy fails
    //         console.error("Could not copy text: ", err);
    //         alert("Failed to copy."); // Replace with your toast or alert system
    //       });
    //   } else {
    //     // Clipboard API not available
    //     console.error("Clipboard API not available.");
    //     alert("Clipboard functionality not available."); // Replace with your toast or alert system
    //   }
    // },
    // onBlurMount() {
    //   console.log(this.retiroCash);

    //   if (
    //     this.retiroCash == null ||
    //     this.retiroCash == "null" ||
    //     this.retiroCash == ""
    //   ) {
    //     this.retiroCash = "";
    //   } else {
    //     if (Number(this.retiroCash) === Number("0")) {
    //       this.retiroCash = "";

    //       this.$toast.error("El monto del retiro no puede ser igual a cero", {
    //         position: "top-right",
    //         max: 10,
    //       });
    //     }
    //   }
    // },

    getSaldo() {
      const userIdEncripted = this.$encryptBackoffice.encrypt(this.userId);

      // this.$https
      //   .post("/", { tokenAuth: this.tokenAuth, userId: userIdEncripted })
      //   .then((response) => {
      //     // this.$https.post('/profile/getBalance/', { tokenAuth: this.tokenAuth, userId: userIdEncripted }).then(response => {

      //     if (response.data.code == 200) {
      //       this.loading = false;
      //       (this.isDisable = false),
      //         (this.availableBalance = response.data.balance);
      //     } else {
      //       if (response.data.code == 401) {
      //         localStorage.removeItem("userData");
      //         this.$store.state.user = "";

      //         // Redirect to login page
      //         this.$router.push({ name: "Signin" });
      //       } else {
      //         this.getSaldo();
      //       }
      //     }
      //   })
      //   .catch((error) => {
      //     this.getSaldo();
      //   });
    },
    sendCash(event) {
      event.preventDefault();

      if (this.availableBalance === 0) {
        this.$toast.error("No existe dinero para retirar", {
          position: "top-right",
          max: 10,
        });
      } else {
        this.$swal({
          title:
            "¿Seguro que deseas hacer un retiro por $" +
            this.availableBalance +
            "?",
          icon: "warning",
          width: "400px",
          showCancelButton: true,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-secondary btn-outline-secondary ml-1",
          },
          buttonsStyling: false,
          showLoaderOnConfirm: true,
          preConfirm: () => {
            this.isDisable = true;

            const userId_json = {
              userId: this.userId,
            };

            return this.$https
              .post("/balance/withdrawBalance/", userId_json)
              .then((response) => {
                return response;
              })
              .catch((error) => {
                // this.$swal.showValidationMessage(error);
                console.log("error", error);
              });
          },
          allowOutsideClick: () => !this.$swal.isLoading(),
          backdrop: true,
        }).then((result) => {
          this.$swal.close();
          if (result.isConfirmed) {
            this.isDisable = false;

            if (result.value.data.code == 200) {
              this.$toast.success(result.value.data.message, {
                position: "top-right",
                max: 10,
              });

              this.$eventBus.emit("closeModalRetiro");
              this.$eventBus.emit("reiniciarSaldos");
              this.isDisable = false;
            } else if (result.value.data.code == 404) {
              // localStorage.removeItem("userData");
              // this.$store.state.user = "";

              // // Redirect to login page
              // this.isDisable = false;
              // this.$router.push({ name: "Signin" });
              this.$eventBus.emit("closeModalRetiro");
              this.$toast.error(result.value.data.message, {
                position: "top-right",
                max: 10,
              });
              this.isDisable = false;
              if (
                result.value.data.message !==
                "Ya existe una solicitud pendiente de retiro"
              ) {
                this.$router.push({ name: "banco" });
              }
            } else {
              this.$toast.error(result.value.data.message, {
                position: "top-right",
                max: 10,
              });
              this.isDisable = false;
            }
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.invoice-container {
  display: flex;
  flex-direction: column;
  padding: 10px;
  border: 1px solid #cdcdcd;
  border-radius: 5px;
  margin-bottom: 20px;
}

.invoice-header {
  display: flex;
  justify-content: space-between;
  /* margin-bottom: 12px; */
}

/* .company-info, */

.commissions,
.invoice-info,
.totals {
  border: 1px solid #cdcdcd;
  border-radius: 5px;
  padding: 4px;
  margin-bottom: 10px;
}

.client-info {
  border: 1px solid #cdcdcd;
  border-radius: 5px;
  padding: 8px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.invoice-info {
  text-align: center;
  height: fit-content;
}

.input-group {
  display: flex;
  flex-direction: column;
}

.input-group p .input-group h6 {
  font-size: 12px;
  font-weight: 600;
  display: block;
}

.commissions,
.totals,
.commissions-title {
  display: flex;
  padding: 0 8px;
}

.commissions {
  justify-content: space-between;
  align-items: center;
}
.commissions-title {
  justify-content: space-between;
}

.totals {
  text-align: right;
  flex-direction: column;
  width: fit-content;
  align-self: flex-end;
  gap: 4px;
}

.value {
  display: flex;
  gap: 6px;
  width: 100%;
  justify-content: space-between;
}

.address {
  display: flex;
}

.company-data-2-fields {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  @media (max-width: 400px) {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
